import {Injectable, Optional} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Employee, EmployeeSearch} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';

interface IResponseItem {
  type: string,
  firstName: string,
  invitationId: string,
  invitationStatus: string,
  lastName: string,
  networkPartner: NetworkPartner[],
  userId: string
}

interface NetworkPartner {
  "networkPartnerId": string,
  "networkPartnerName": string
}

export interface EmployeePagination {
  page: number;
  perPage: number;
  totalPages: number;
  count: number;
  totalCount: number;
}

interface SearchResponse {
  results: IResponseItem[],
  pagination: EmployeePagination,
}

@Injectable({
  providedIn: 'root'
})
export class EmployeeConnectors {

  private readonly _rootUrl: string;
  private readonly _baseSite: string;

  private route = '/access/employees';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite;
  }

  private static transformFromApi(response: IResponseItem): Employee {
    return {
      ...response,
      id: response.userId + '-' + response.invitationId,
      networkPartner: response.networkPartner.map(
        (networkPartner) => {
          return {
            id: networkPartner.networkPartnerId,
            name: networkPartner.networkPartnerName
          }
        }
      )
    };
  }

  search(
     query: string,
     page: number,
     pageSize: number
  ): Observable<EmployeeSearch> {
    let searchOptions = 'currentPage=' + (page - 1) + '&pageSize=' + pageSize;
    if (query) {
      searchOptions = searchOptions + '&query=' + query;
    }
    return this.http.get<SearchResponse>(this.getManyUrl() + '?' + searchOptions).pipe(
       map(
          (response: SearchResponse) => {
            return {
              pagination: response.pagination,
              employees: response.results.map((item: IResponseItem) => EmployeeConnectors.transformFromApi(item)),
            }
          }
       ),
       catchError(
          error => throwError(error)
       )
    )
  }

  protected getManyUrl() {
    return this._rootUrl + this._baseSite + this.route;
  }

  protected getOneUrl(id: number) {
    return this._rootUrl + this.route + id;
  }
}
